export const appendErrorDetails = (ex: unknown) => {
  if (!ex || typeof ex !== 'object' || !('body' in ex)) return '';

  const { body } = ex;
  if (!body || typeof body !== 'object' || !('detail' in body)) return '';

  const { detail } = body;
  if (typeof detail !== 'string' || !detail.length) return '';

  return `\nDetails: ${detail}`;
};
